import { useMediaQuery } from "react-responsive";
import { Outlet, useLocation } from "react-router-dom";
import LeftContent from "../LeftContent/LeftContent";

const Reports = () => {
    const location = useLocation();
    const isDesktopOrLaptop = useMediaQuery({
        query: "(min-width: 1224px)",
      });
      const isIncomeProjection = location.pathname.includes("incomeProjection");
      return (
        <div className="HomePurchaseStep3Form">
          <div className="content">
            {isDesktopOrLaptop && (
              <div className="left">
                <LeftContent />
              </div>
            )}
            <div className={`${isIncomeProjection ? "portfolioRight_w100" : "portfolioRight"}`}>
              <Outlet />
            </div>
          </div>
        </div>
      );
};

export default Reports;
